'use client';

import { useSession } from '@repo/auth';
import { useEffect, useRef } from 'react';
import { flushAttribution } from '../flush-attribution';

export function useFlushAttributionOnSession(): void {
  const { data: session } = useSession();
  const flushedForRef = useRef<string | null>(null);

  useEffect(() => {
    const userId = session?.user?.id;
    if (!userId) {
      return;
    }
    if (flushedForRef.current === userId) {
      return;
    }
    flushedForRef.current = userId;
    flushAttribution();
  }, [session]);
}
